import { render, staticRenderFns } from "./CardValidaDocuments.vue?vue&type=template&id=5aa9d72b&scoped=true"
import script from "./CardValidaDocuments.vue?vue&type=script&lang=js"
export * from "./CardValidaDocuments.vue?vue&type=script&lang=js"
import style0 from "./CardValidaDocuments.vue?vue&type=style&index=0&id=5aa9d72b&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5aa9d72b",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/runner/work/hive-platform-web/hive-platform-web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('5aa9d72b')) {
      api.createRecord('5aa9d72b', component.options)
    } else {
      api.reload('5aa9d72b', component.options)
    }
    module.hot.accept("./CardValidaDocuments.vue?vue&type=template&id=5aa9d72b&scoped=true", function () {
      api.rerender('5aa9d72b', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/LivenessHiveDetail/components/CardValidaDocuments.vue"
export default component.exports